import React from 'react'
import './index.less'

const CardBox = (props) => {
		return (
			<div className="jx-card-box">
				<div className="jx-card-box-title">{props.title}</div>
				{
					props.children
				}
			</div>
		)
}

export default CardBox